<template>
  <div class="pc-bp">
    <!-- 院校头部面包屑部分 -->
    <div class="pc-bp-bread">
      <h2>BP列表</h2>
      <BreadCrumb :data="breadcrumb" class="pc-new-breadcrumb" />
    </div>

     <StatisticalPanel
      :whichModule="'bestpractice'"
      :data="overallData"
    ></StatisticalPanel>
    <!-- bp奖项管理 -->
    <div class="pc-bp-awards">
      <!-- bp奖项头部管理 -->
      <div class="pc-bp-awards-manager">
        <h2>奖项管理</h2>
        <div>
          <button
            v-show="managerAwardsState == false"
            class="pc-search-clickBtn addbtn"
            @click="addAwards"
          >
            添加
          </button>
          <button
            @click="awardsManager"
            v-show="managerAwardsState == false"
            class="pc-search-clickBtn"
          >
            管理
          </button>
          <button
            @click="awardsManagerSave"
            v-show="managerAwardsState"
            class="pc-search-clickBtn"
          >
            完成
          </button>
        </div>
      </div>
      <!-- bp奖项内容管理 -->
      <ul :class="managerAwardsState ? 'copyreader' : ''">
        <li
          v-for="(item, index) in awardsList"
          :key="index"
          class="state"
          :class="item.status != 1 ? 'lost-state' : ''"
          @click="choiceAwards(item.id, item.name, item.englishName)"
        >
          <div v-if="item.image" class="stateImg">
            <img :src="item.image" />
          </div>
          <dl>
            <dd>{{ item.name ? item.name : item.englishName }}</dd>
            <dt>
              <li v-if="item.category=='PersonAward'" class="person"><span>{{item.practiceNums}}</span><span>人物</span></li>
              <li v-if="item.category=='PaperAward'" class="works"><span>{{item.practiceNums}}</span><span>作品</span></li>
            </dt>
          </dl>

          <div v-if="item.status != 1" class="lost-icon">无效</div>
          <!-- 点击编辑显示的删除样式 -->
          <div
            v-show="managerAwardsState"
            @click="deletePracticeAwardss(item.id)"
            class="choice-delete"
          >
            <i class="el-icon-error"></i>
          </div>
        </li>
      </ul>
      <ol v-if="practiceAwardsArgs.total > 12">
        <li
          v-for="(item, index) in practiceAwardsArgs.cell"
          :key="index"
          :class="practiceAwardsArgs.skip == 12 * index ? 'choicePage' : ''"
          @click="changePage(index)"
        ></li>
      </ol>
    </div>
    <!-- bp标签管理 -->
    <!-- <div class="pc-bp-tab"> -->
      <Tag :typeTagArgs="typeTagArgs" @refresh="refresh"/>
    <!-- </div> -->
    <!-- bp表格 -->
    <div class="pc-bp-table">
      <BestPracticeTable ref="uniTable"/>
    </div>
    <!-- 提示框 -->
    <DeleteDialog
      @isDelete="isDelete"
      @isCancel="isCancel"
      :dialogVisible="deleteShow"
      :delid="deleteId"
      :delContent="delContent"
    />
  </div>
</template>
<script>
// 功能模板
import DeleteDialog from "../../template/DeleteDialog";
// 页面模板
import StatisticalPanel from "../../componentSet/Statistical/StatisticalPanel.vue";

import BreadCrumb from "../../template/BreadCrumb";

import BestPracticeTable from "./components/BestPracticeTable";
import Tag from "../../template/Tag";

import {
  getDictionaries,
  getPersons,
  getPractices,
} from "./bestPracticeList.gql";
import { getPracticeAwards, deletePracticeAwards } from "./awards.gql";
export default {
  components: {
    BreadCrumb,

    BestPracticeTable,
    DeleteDialog,
    Tag,
    StatisticalPanel,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "BP管理", link: "/" },
        { name: "BP列表", link: "" },
      ];
    },
  },
  data() {
    return {
      overallData: {
        title: "BP数据",
        count: [{ name: "BP数量", count: null },{ name: "奖项数量", count: null }],
      },
      // 删除dialog的显示文字
      delContent:'如果要删除该奖项，该奖项下的所有列表将会取消',
      // 头部人物数量
      teacherTotal: null,
      // 头部优秀作品数量
      bpListTotal: null,
      // 选择是昨天还是前天
      tabPosition: "top",
      // 时间选择器
      timeChoice: "",
      // 后端需要的参数
      dailyStatisticsesArgs: {
        fromCurrentDate: "",
        toCurrentDate: "",
      },
      // 奖项接口后端需要的接口
      practiceAwardsArgs: {
        skip: 0,
        status: -1,
        take: 12,
        total: 0,
        cell: 0,
        order:'-status'
      },
      // 奖项数组
      awardsList: [],
      // 标签接口
      typeTagArgs: {
        skip: 0,
        type: "BP",
        title: "BP",
        order: "+createTime",
      },
      // 所在地的数组
      locationList: [
        { name: "上海", id: 1 },
        { name: "北京", id: 2 },
        { name: "海外", id: 3 },
      ],
      form: {
        tagType: "",
        tag: "",
        type: [],
      },
      // manager 修改显示的
      managerState: false,
      // manager 修改显示的icon
      managericon: false,
      // managerAwardsState 修改奖项的显示
      managerAwardsState: false,
      // finishAwardsState 修改奖项
      finishAwardsState: false,
      // tagTitle
      tagTitle: "-1",
      // tagName
      tagName: "所在地",
      dataArgs:{
        take:1
      },
      // tag标签
      tag: [
        { name: "大洲", tagList: [] },
        { name: "国家", tagList: [] },
        { name: "城市", tagList: [] },
      ],
      // 大洲字段
      tagList: [],
      // 国家字段
      countryList: [],
      // 城市字段
      cityList: [],
      // 查询选中是哪个标签
      secondLevel: [],
      // 底色模板
      searchTemplete: false,
      // 删除面板的显示隐藏
      deleteShow: false,
      // 删除面板的Id
      deleteId: "-1",
      // 判断当前删除的是父标签还是子标签
      checkDeleteTagType: "",
    };
  },
  created() {
 
    // 获取一次BP列表
    this.getPractices();
    this.dailyStatisticsesArgs.toCurrentDate = new Date();
    this.dailyStatisticsesArgs.fromCurrentDate = new Date(
      this.dailyStatisticsesArgs.toCurrentDate.getTime() - 24 * 60 * 60 * 1000
    );
  },
  mounted() {
    this.getPracticeAwards();
    // this.getContinentDicList();
    // this.getCountryDicList();
    // this.getCityDicList();
  },
  methods: {
    // 获取BP列表总数
    getPractices() {
      this.$global
        .GraphqlQuery(this, getPractices, this.dataArgs)
        .then((res) => {
          this.overallData.count[0].count= res.total
          // this.bpListTotal = res.total;
        });
    },
  
    // 奖项管理
    getPracticeAwards() {
      this.$global
        .GraphqlQuery(this, getPracticeAwards, this.practiceAwardsArgs)
        .then((res) => {
          this.overallData.count[1].count= res.total
          this.practiceAwardsArgs.total = res.total;
          this.practiceAwardsArgs.cell = Math.ceil(res.total / 12);
          this.awardsList = res.data;
        });
    },
    // 奖项分页
    changePage(index) {
      this.practiceAwardsArgs.skip = 12 * index;
      // this.
      this.getPracticeAwards();
    },
    // 获取大洲字典
    getContinentDicList() {
      this.$global
        .GraphqlQuery(this, getDictionaries, {
          // Parameters
          type: "university_continent",
        })
        .then((res) => {
          this.tag[0].tagList = res.data;
        });
    },
    // 获取国家字典
    getCountryDicList() {
      this.$global
        .GraphqlQuery(this, getDictionaries, {
          type: "university_country",
        })
        .then((res) => {
          this.tag[1].tagList = res.data;
        });
    },
    // 获取城市字典
    getCityDicList() {
      this.$global
        .GraphqlQuery(this, getDictionaries, {
          // Parameters
          type: "university_city",
        })
        .then((res) => {
          this.tag[2].tagList = res.data;
        });
    },
    // 添加更改
    addAwards() {
      this.$router.push({
        path: "/admin/awardslist",
        name: "awardslist",
      });
    },
    
    // 管理奖项的编辑按钮
    awardsManager() {
      // 将自己的内容显示
      this.managerAwardsState = true;
      //  隐藏其他编辑内容
      this.managerState = false;
      this.managericon = false;
    },
    // 管理奖项的保存按钮
    awardsManagerSave() {
      this.managerAwardsState = false;
    },
    // 管理奖项的点击进入详情功能
    choiceAwards(id, name, englishName) {
      if (this.managerAwardsState == false && name != null) {
        this.$router.push({
          path: "/admin/awardslist",
          query: { id: id, name: name },
          name: "awardslist",
        });
      } else if (this.managerAwardsState == false && name == null) {
        this.$router.push({
          path: "/admin/awardslist",
          query: { id: id, name: englishName },
          name: "awardslist",
        });
      }
    },
    //
    deletePracticeAwardss(id) {
      this.deleteId = id;
      this.deleteShow = true;
    },
    // 刷新搜索框
    refresh(){
      this.$refs.uniTable.neeedReSearch()
    },
    isCancel() {
      this.deleteShow = false;
    },

    isDelete(id) {
      let data = { ids: [id] };
      if (this.managerAwardsState == true) {
        this.$global
          .GraphqlMutation(this, deletePracticeAwards, {
            data: data,
          })
          .then((res) => {
            this.getPracticeAwards();
          });
      }
      this.deleteShow = false;
    },
    changeTime(tab, event) {
      // 计算今天的日期
      this.dailyStatisticsesArgs.fromCurrentDate = new Date();
      // 将拿到的日期时分秒转换成00：00:00格式
      this.dailyStatisticsesArgs.fromCurrentDate.setHours(0);

      this.dailyStatisticsesArgs.fromCurrentDate.setMinutes(0);

      this.dailyStatisticsesArgs.fromCurrentDate.setSeconds(0);

      this.dailyStatisticsesArgs.fromCurrentDate.setMilliseconds(0);
      // 计算明天的日期
      this.dailyStatisticsesArgs.toCurrentDate = new Date(
        this.dailyStatisticsesArgs.fromCurrentDate.getTime() +
          24 * 60 * 60 * 1000
      );
      // 将拿到的日期时分秒转换成00：00:00格式
      this.dailyStatisticsesArgs.toCurrentDate.setHours(0);

      this.dailyStatisticsesArgs.toCurrentDate.setMinutes(0);

      this.dailyStatisticsesArgs.toCurrentDate.setSeconds(0);

      this.dailyStatisticsesArgs.toCurrentDate.setMilliseconds(0);

      if (tab == "yesterdayLater") {
        this.dailyStatisticsesArgs.toCurrentDate =
          this.dailyStatisticsesArgs.fromCurrentDate;
        this.dailyStatisticsesArgs.fromCurrentDate = new Date(
          this.dailyStatisticsesArgs.fromCurrentDate.getTime() -
            24 * 60 * 60 * 1000
        );
      } else if (tab == "weekLater") {
        this.dailyStatisticsesArgs.toCurrentDate =
          this.dailyStatisticsesArgs.fromCurrentDate;
        this.dailyStatisticsesArgs.fromCurrentDate = new Date(
          this.dailyStatisticsesArgs.toCurrentDate.getTime() -
            6 * 24 * 60 * 60 * 1000
        );
      } else if (tab == "monthLater") {
        this.dailyStatisticsesArgs.toCurrentDate =
          this.dailyStatisticsesArgs.fromCurrentDate;
        this.dailyStatisticsesArgs.fromCurrentDate = new Date(
          this.dailyStatisticsesArgs.toCurrentDate.getTime() -
            30 * 24 * 60 * 60 * 1000
        );
      }
      //   this.getDailyStatisticses();
    },
    // 点击渲染
    pickerOptions(value) {
      this.dailyStatisticsesArgs.fromCurrentDate = value[0];
      this.dailyStatisticsesArgs.toCurrentDate = value[1];
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-bp {
  // bp头部面包屑部分
  .pc-bp-bread {
    display: flex;
    padding-bottom: 20px;
    border-bottom: 2px solid $border-color;
    > h2 {
      font-size: 20px;
      padding: 35px 40px 0 0;
      align-self: flex-end;
    }
  }
  .slot-first{
  ul {
        margin-top: 25px;

        li {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          .title-label {
            display: flex;
            justify-content: center;

            h2 {
              width: 60px;
              align-self: center;
              font-size: 14px;
              text-align: center;
              color: $mainTitle;
              // margin-right: 20px;
            }
          }
          .title-label {
            display: flex;
            width: 100%;
            justify-content: center;
            span {
              align-self: center;
              font-size: 60px;
              margin-bottom: 5px;
              color: $visitorVolumeSmall;
            }
          }
        }
        li:nth-of-type(1) {
          span {
            color: $timeBtn;
          }
        }
        // li:nth-of-type(2), {
        //   span {

        //   }
        // }
      }
  }
  // bp奖项管理
  .pc-bp-awards {
    box-shadow: $boxshadow;
    padding: 30px 30px 10px;
    margin-top: 40px;
    // margin-right: 40px;
    border-radius: 4px;
    // bp奖项头部内容
    .pc-bp-awards-manager {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid $border-color;
      > h2 {
        font-size: 20px;
        padding-bottom: 15px;
        color: $mainTitle;
      }
      .pc-search-clickBtn {
        width: 90px;
        height: 40px;
        background: $blueBtn;
        border-radius: 4px;
        margin-bottom: 15px;
        outline: none;
        border: none;
        font-family: $chinese;
        font-size: 14px;
        color: white;
        cursor: pointer;
      }
      .addbtn {
        margin-right: 20px;
        background: $test;
        color: $blueBtna;
        border: 1px solid $blueBtna;
      }
    }

    // bp奖项内容显示
    ul {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-top: 30px;
      > li {
        // position: relative;
        width: 239px;
        height: 82px;
        border: 1px solid $schoolTagBorder;
        display: flex;
        justify-content: space-between;
        margin-right: 20px;
        // margin-left: 10px;
        margin-bottom: 30px;
        // margin-left: 40px;
        border-radius: 4px;
        cursor: pointer;
        .stateImg {
          width: 100px;
          height: 80px;
          img {
            width: 105px;
            height: 80px;
            object-fit: fill;
            margin-right: 10px;
          }
        }
        dl {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin: 0;
          margin-left: 15px;
          padding-right: 10px;
          dd {
            font-size: 14px;
            margin: 0;
            margin-top: 8px;
            clear: both;
            overflow: hidden;
            text-overflow: ellipsis;
            // -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          dt {
            display: flex;
            justify-content: space-between;
            margin-top: 8px;
            margin-bottom: 8px;
            li {
              font-size: 12px;
            }
            .person {
              span {
                color: $blueBtna;
              }
            }
            .works {
              span {
                color: $visitorVolumeSmall;
              }
              span:nth-of-type(2){
                color: $thirdTitle;
              }
            }
          }
        }
        .choice-delete {
          // position: absolute;
          width: 25px;
          height: 100%;
          padding: 2.5px;
          display: flex;
          justify-content: center;
          // right: -15px;
          // top: -1px;
          background: $schoolTagBorder;
          border: 1px solid $schoolTagBorder;
          border-radius: 0px 4px 4px 0;
          .el-icon-error {
            background: $schoolTagBorder;
            align-self: center;
          }
          .el-icon-error:before {
            background-color: $base-color;
            border-radius: 20px;
          }
        }
      }
      // li:nth-child(6n + 1) {
      //   margin-left: 0;
      // }
      // li:nth-child(6n + 6) {
      //   margin-right: 0;
      // }
      .lost-state {
        opacity: 0.44;
        position: relative;
        overflow: hidden;
        .lost-icon {
          position: absolute;
          width: 60px;
          top: 6px;
          left: -16px;
          text-align: center;
          background: $blueBtna;
          font-size: 10px;
          font-weight: 400;
          color: $base-color;
          transform: rotate(-45deg);
        }
      }
    }
    /deep/ .copyreader {
      li {
        // background: red;
        width: 247 !important;
        margin-right: 5px;
        margin-left: 5px;
        dl {
          padding-right: 3px;
        }
      }
    }
    // bp奖项轮播图
    ol {
      display: flex;
      justify-content: center;
      li {
        border-radius: 3px;
        cursor: pointer;
        width: 34px;
        height: 5px;
        background: $schoolTagBorder;
        margin-right: 10px;
      }
      .choicePage {
        background: $blueBtna;
      }
    }
  }
  // bp表单
  .pc-bp-table {
    // box-shadow: $boxshadow;
    // padding: 35px 30px;
    margin-top: 40px;
    // margin-right: 40px;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
      border-bottom: 2px solid $border-color;
    }
  }
  // 模块
  .search-templete {
    width: 100vw;
    height: 100vh;
    background: black;
    position: fixed;
    top: 0;
    opacity: 0;
  }
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: $timeBtn;
  border-color: $timeBtn;
  box-shadow: -1px 0 0 0 $timeBtn;
}
/deep/ .el-radio-button__inner{color: #909399;}
// /deep/ .el-radio-button__inner:hover{color: #5470C6;}
// 日期选择器样式
/deep/ .el-date-editor .el-range-separator {
  width: 10%;
}
/deep/ .el-date-editor .el-range__icon {
  font-size: 20px;
  position: absolute;
  right: 8px;
  top: 2px;
}
// elForm 弹出框的样式
/deep/ .el-dialog {
  width: 31%;
  box-shadow: $boxshadow;
  border-radius: 4px;
  .el-form {
    display: flex;
    justify-content: space-around;
  }
  .el-dialog__footer {
    padding: 10px 25% 30px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: space-around;
      .el-button--default:hover {
        background: $base-color;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
      .el-button--default{

      }
       .el-button--default:hover{
         span{color: $blueBtna}
       }
    }
  }
}
.el-dialog__body{
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/bestPractice/BestPracticeList.vue